import {makeAutoObservable, reaction, runInAction} from 'mobx'
import config from 'src/config'
import {MainStore} from 'src/store/MainStore'
import User from 'src/entities/User'

export default class UsersStore {
  users?: User[]

  constructor(readonly owner: MainStore) {
    makeAutoObservable(this)

    reaction(
      () => this.owner.loginStore.isMsalAuth,
      isAuth => {
        if (isAuth) {
          this.getUsers()
        }
      }
    )
  }

  getUsers = () => {
    this.owner.loginStore
      .fetchWithUser(`${config.apiUrl}/Users/all`)
      .then(res => {
        return res.json()
      })
      .then((data: any) => {
        if (data) {
          runInAction(() => {
            this.users = data.map((u: any) => new User(u))
          })
        }
      })
      .catch(e => {
        console.log('error:', e)
      })
  }
}
